import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

constructor(private http: HttpClient) { }

UploadMemberImage(formData: any) {

  return this.http.post<any>(environment.apiUrl + 'File/UploadMemberImage', formData);
}

DeleteMemberImage(memberid: number) {
  return this.http.delete<any>(environment.apiUrl + 'File/DeleteMemberImage/' + memberid);
}

UploadInstitutionEmblem(formData: any) {
  return this.http.post<any>(environment.apiUrl + 'File/UploadInstitutionEmblem', formData);
}

GetEmblemImage(institutionid: number): Observable<Blob> {
  return this.http.get(environment.apiUrl + 'File/GetEmblemImage/' + institutionid, { responseType: 'blob' });
}

 GetHelpVideo(videoName: string): Observable<any> {
   return this.http.get(environment.apiUrl + 'File/GetHelpVideo/' + videoName, { responseType: 'blob' });
}
}
